import { render, staticRenderFns } from "./TgCjEleganceMore.vue?vue&type=template&id=2acafdd5&"
import script from "./TgCjEleganceMore.vue?vue&type=script&lang=js&"
export * from "./TgCjEleganceMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports